import BaseAPI from '@/apis/base'
import { apis, getApiUrl } from '../api-config'
/**
 * API xử lý lớp học
 */
class AnswerOverviewAPI extends BaseAPI {}

// export default new ClassroomAPI('v1/classrooms', 'ClassRoom', getApiUrl(apis.TeacherAPI)) //tesst
export default new AnswerOverviewAPI('v1/student-exercises', 'SubmitExercise', getApiUrl(apis.StudentAPI))
